import { render, staticRenderFns } from "./list-content.vue?vue&type=template&id=04591a65&scoped=true&"
import script from "./list-content.vue?vue&type=script&lang=ts&"
export * from "./list-content.vue?vue&type=script&lang=ts&"
import style0 from "./list-content.vue?vue&type=style&index=0&id=04591a65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04591a65",
  null
  
)

export default component.exports